app
    .controller('CoachPersonalFormCtrl', function CoachImageFormCtrl($http) {

        this.$onInit = () => {
            this.coach = this.resolve.coach;
        };

        this.specialities = [
            "Yoga",
            "Cricket",
            "Football",
        ];

        this.timezones = [
            "[UTC - 12] Baker Island Time",
            "[UTC - 11] Niue Time, Samoa Standard Time",
            "[UTC - 10] Hawaii-Aleutian Standard Time, Cook Island Time",
            "[UTC - 9:30] Marquesas Islands Time",
            "[UTC - 9] Alaska Standard Time, Gambier Island Time",
            "[UTC - 8] Pacific Standard Time",
            "[UTC - 7] Mountain Standard Time",
            "[UTC - 6] Central Standard Time",
            "[UTC - 5] Eastern Standard Time",
            "[UTC - 4:30] Venezuelan Standard Time",
            "[UTC - 4] Atlantic Standard Time",
            "[UTC - 3:30] Newfoundland Standard Time",
            "[UTC - 3] Amazon Standard Time, Central Greenland Time",
            "[UTC - 2] Fernando de Noronha Time, South Georgia &amp; the South Sandwich Islands Time",
            "[UTC - 1] Azores Standard Time, Cape Verde Time, Eastern Greenland Time",
            "[UTC] Western European Time, Greenwich Mean Time",
            "[UTC + 1] Central European Time, West African Time",
            "[UTC + 2] Eastern European Time, Central African Time",
            "[UTC + 3] Moscow Standard Time, Eastern African Time",
            "[UTC + 3:30] Iran Standard Time",
            "[UTC + 4] Gulf Standard Time, Samara Standard Time",
            "[UTC + 4:30] Afghanistan Time",
            "[UTC + 5] Pakistan Standard Time, Yekaterinburg Standard Time",
            "[UTC + 5:30] Indian Standard Time, Sri Lanka Time",
            "[UTC + 5:45] Nepal Time",
            "[UTC + 6] Bangladesh Time, Bhutan Time, Novosibirsk Standard Time",
            "[UTC + 6:30] Cocos Islands Time, Myanmar Time",
            "[UTC + 7] Indochina Time, Krasnoyarsk Standard Time",
            "[UTC + 8] Chinese Standard Time, Australian Western Standard Time, Irkutsk Standard Time",
            "[UTC + 8:45] Southeastern Western Australia Standard Time",
            "[UTC + 9] Japan Standard Time, Korea Standard Time, Chita Standard Time",
            "[UTC + 9:30] Australian Central Standard Time",
            "[UTC + 10] Australian Eastern Standard Time, Vladivostok Standard Time",
            "[UTC + 10:30] Lord Howe Standard Time",
            "[UTC + 11] Solomon Island Time, Magadan Standard Time",
            "[UTC + 11:30] Norfolk Island Time",
            "[UTC + 12] New Zealand Time, Fiji Time, Kamchatka Standard Time",
            "[UTC + 12:45] Chatham Islands Time",
            "[UTC + 13] Tonga Time, Phoenix Islands Time",
            "[UTC + 14] Line Island Time",
        ];
        this.professions = [
            "Coach",
            "Kinesiologist",
            "Life coach",
            "Physical educator",
            "Sport scientist",
            "Physiotherapy",
            "Osteopath",
            "Naturopath",
            "Massage therapist",
            "Functional training",
            "Rehabilitation",
            "Martial artist",
        ];
        this.countries = [
            "Afghanistan",
            "Albania",
            "Algeria",
            "American Samoa",
            "Andorra",
            "Angola",
            "Anguilla",
            "Antigua & Barbuda",
            "Argentina",
            "Armenia",
            "Aruba",
            "Australia",
            "Austria",
            "Azerbaijan",
            "Bahamas",
            "Bahrain",
            "Bangladesh",
            "Barbados",
            "Belarus",
            "Belgium",
            "Belize",
            "Benin",
            "Bermuda",
            "Bhutan",
            "Bolivia",
            "Bonaire",
            "Bosnia & Herzegovina",
            "Botswana",
            "Brazil",
            "British Indian Ocean Ter",
            "Brunei",
            "Bulgaria",
            "Burkina Faso",
            "Burundi",
            "Cambodia",
            "Cameroon",
            "Canada",
            "Canary Islands",
            "Cape Verde",
            "Cayman Islands",
            "Central African Republic",
            "Chad",
            "Channel Islands",
            "Chile",
            "China",
            "Christmas Island",
            "Cocos Island",
            "Colombia",
            "Comoros",
            "Congo",
            "Cook Islands",
            "Costa Rica",
            "Cote DIvoire",
            "Croatia",
            "Cuba",
            "Curacao",
            "Cyprus",
            "Czech Republic",
            "Denmark",
            "Djibouti",
            "Dominica",
            "Dominican Republic",
            "East Timor",
            "Ecuador",
            "Egypt",
            "El Salvador",
            "Equatorial Guinea",
            "Eritrea",
            "Estonia",
            "Ethiopia",
            "Falkland Islands",
            "Faroe Islands",
            "Fiji",
            "Finland",
            "France",
            "French Guiana",
            "French Polynesia",
            "French Southern Ter",
            "Gabon",
            "Gambia",
            "Georgia",
            "Germany",
            "Ghana",
            "Gibraltar",
            "Great Britain",
            "Greece",
            "Greenland",
            "Grenada",
            "Guadeloupe",
            "Guam",
            "Guatemala",
            "Guinea",
            "Guyana",
            "Haiti",
            "Hawaii",
            "Honduras",
            "Hong Kong",
            "Hungary",
            "Iceland",
            "Indonesia",
            "India",
            "Iran",
            "Iraq",
            "Ireland",
            "Isle of Man",
            "Israel",
            "Italy",
            "Jamaica",
            "Japan",
            "Jordan",
            "Kazakhstan",
            "Kenya",
            "Kiribati",
            "Korea North",
            "Korea South",
            "Kuwait",
            "Kyrgyzstan",
            "Laos",
            "Latvia",
            "Lebanon",
            "Lesotho",
            "Liberia",
            "Libya",
            "Liechtenstein",
            "Lithuania",
            "Luxembourg",
            "Macau",
            "Macedonia",
            "Madagascar",
            "Malaysia",
            "Malawi",
            "Maldives",
            "Mali",
            "Malta",
            "Marshall Islands",
            "Martinique",
            "Mauritania",
            "Mauritius",
            "Mayotte",
            "Mexico",
            "Midway Islands",
            "Moldova",
            "Monaco",
            "Mongolia",
            "Montserrat",
            "Morocco",
            "Mozambique",
            "Myanmar",
            "Nambia",
            "Nauru",
            "Nepal",
            "Netherland Antilles",
            "Netherlands (Holland, Europe)",
            "Nevis",
            "New Caledonia",
            "New Zealand",
            "Nicaragua",
            "Niger",
            "Nigeria",
            "Niue",
            "Norfolk Island",
            "Norway",
            "Oman",
            "Pakistan",
            "Palau Island",
            "Palestine",
            "Panama",
            "Papua New Guinea",
            "Paraguay",
            "Peru",
            "Philippines",
            "Pitcairn Island",
            "Poland",
            "Portugal",
            "Puerto Rico",
            "Qatar",
            "Republic of Montenegro",
            "Republic of Serbia",
            "Reunion",
            "Romania",
            "Russia",
            "Rwanda",
            "St Barthelemy",
            "St Eustatius",
            "St Helena",
            "St Kitts-Nevis",
            "St Lucia",
            "St Maarten",
            "St Pierre & Miquelon",
            "St Vincent & Grenadines",
            "Saipan",
            "Samoa",
            "Samoa American",
            "San Marino",
            "Sao Tome & Principe",
            "Saudi Arabia",
            "Senegal",
            "Seychelles",
            "Sierra Leone",
            "Singapore",
            "Slovakia",
            "Slovenia",
            "Solomon Islands",
            "Somalia",
            "South Africa",
            "Spain",
            "Sri Lanka",
            "Sudan",
            "Suriname",
            "Swaziland",
            "Sweden",
            "Switzerland",
            "Syria",
            "Tahiti",
            "Taiwan",
            "Tajikistan",
            "Tanzania",
            "Thailand",
            "Togo",
            "Tokelau",
            "Tonga",
            "Trinidad & Tobago",
            "Tunisia",
            "Turkey",
            "Turkmenistan",
            "Turks & Caicos Is",
            "Tuvalu",
            "Uganda",
            "United Kingdom",
            "Ukraine",
            "United Arab Emirates",
            "United States of America",
            "Uruguay",
            "Uzbekistan",
            "Vanuatu",
            "Vatican City State",
            "Venezuela",
            "Vietnam",
            "Virgin Islands (Brit)",
            "Virgin Islands (USA)",
            "Wake Island",
            "Wallis & Futana Is",
            "Yemen",
            "Zaire",
            "Zambia",
            "Zimbabwe"
        ];

        this.languages = ['en', 'fr'];

        this.isProfessionSelected = (profession) => {
            return this.coach.professions.indexOf(profession) >= 0;
        };

        this.toggleProfession = (profession) => {
            if (this.isProfessionSelected(profession)) {
                this.coach.professions = this.coach.professions.filter((p) => profession !== p);
            } else {
                this.coach.professions.push(profession);
            }
        };

        this.isLanguageSelected = (language) => {
            return this.coach.languages.indexOf(language) >= 0;
        };

        this.toggleLanguage = (language) => {
            if (this.isLanguageSelected(language)) {
                this.coach.languages = this.coach.languages.filter((p) => language !== p);
            } else {
                this.coach.languages.push(language);
            }
        };

        this.save = () => {
            $http.post(`/coach/update/${this.coach.id}`, this.coach).then(() => {
                this.close();
            });
        };

        this.cancel = () => {
            this.dismiss();
        };
    })
    .component('coachPersonalForm', {
        template: `
        <form ng-submit="$ctrl.save()">
        <div class="modal-header">
            <h3 class="modal-title" id="modal-title">
                <chat-icon type="presentation" width="18"/>
                {{ "modal.personalForm.title" | translate}}
            </h3>
            <button class="btn btn-close" ng-click="$ctrl.cancel()">
                <chat-icon type="cross" width="15" />
            </button>
        </div>
        <div class="modal-body" id="modal-body">
            <div class="form-group">
                <label for="">{{ "modal.personalForm.label.name" | translate}}</label>
                <input type="text" class="form-control" ng-model="$ctrl.coach.name">
            </div>
            <div class="form-group">
                <label for="">{{ "modal.personalForm.label.language" | translate}}</label>
                <div class="row" style="align-items: center;">
                    <div class="col-sm-3" ng-repeat="lang in $ctrl.languages">
                        <div class="form-check" >
                            <input class="form-check-input" type="checkbox" id="lang-{{lang}}" ng-checked="$ctrl.isLanguageSelected(lang)" ng-click="$ctrl.toggleLanguage(lang)">
                            <label class="form-check-label" for="lang-{{lang}}">{{ "modal.personalForm.label." + lang | translate}}</label>
                        </div>
                    </div>
                    <div class="col-sm-6" >
                        <div class="form-check" >
                            <input class="form-control" type="text" ng-model="$ctrl.coach.languageOther" placeholder="{{ 'modal.personalForm.placeholder.other' | translate}}">
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="">{{ "modal.personalForm.label.title" | translate}}</label>
                <input type="text" class="form-control" ng-model="$ctrl.coach.title">
            </div>
            <div class="form-group">
                <label>{{ "modal.personalForm.label.country" | translate}}</label>
                <select class="form-control custom-select" ng-model="$ctrl.coach.country">
                    <option ng-repeat="country in $ctrl.countries" value="{{ country }}">{{ country }}</option>
                </select>
            </div>
            <div class="form-group">
                <label>{{ "modal.personalForm.label.timeZone" | translate}}</label>
                <select class="form-control custom-select" ng-model="$ctrl.coach.timezone">
                    <option ng-repeat="timezone in $ctrl.timezones" value="{{ timezone }}">{{ timezone }}</option>
                </select>
            </div>
            <div class="form-group row">
                <label class="col-12">{{ "modal.personalForm.label.profession" | translate}}</label>
                <div class="col-sm-6" ng-repeat="profession in $ctrl.professions">
                    <div class="form-check" >
                        <input class="form-check-input" type="checkbox" id="gridCheck{{$index}}" ng-checked="$ctrl.isProfessionSelected(profession)" ng-click="$ctrl.toggleProfession(profession)">
                        <label class="form-check-label" for="gridCheck{{$index}}">{{profession}}</label>
                    </div>
                </div>
             </div>
             <div class="form-group">
                <label>{{ "modal.personalForm.label.specialities" | translate}}</label>
                 <ui-select multiple ng-model="$ctrl.coach.specialities" tagging="true"  tagging-label=""  theme="select2"  style="width: 100%">
                    <ui-select-match>{{$item}}</ui-select-match>
                    <ui-select-choices repeat="speciality in $ctrl.specialities | filter:$select.search">
                      {{speciality}}
                    </ui-select-choices>
                  </ui-select>
            </div>
             <div class="form-group">
                <label>{{ "modal.personalForm.label.qualifications" | translate}}</label>
                <textarea class="form-control" ng-model="$ctrl.coach.qualifications"></textarea>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-save" type="submit">{{ "modal.personalForm.button.save" | translate}}</button>
        </div>
        </form>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'CoachPersonalFormCtrl'
    });
